import React from "react";
import NoDataImg from '../../../assets/images/konten-nodata.png';
import { Box } from "@mui/material";
import '../../../styles/pages/customer/konten.scss'

const KontenNoDataPage = () => {
    return (
        <Box display={'flex'} justifyContent={'center'} alignItems={"center"} className="no-data-image">
            <div className="image-container">
                <img src={NoDataImg} alt="No-Data Image" className="responsive-image" />
            </div>
        </Box>
    )
}

export default KontenNoDataPage;